/* eslint @typescript-eslint/no-var-requires: 0 */
import { ILanguageResource } from './types'

// Import dayjs locales
import 'dayjs/locale/en'

function makeResource(translation: ILanguageResource['translation']): ILanguageResource {
	return { translation }
}

export default {
	en: makeResource(require('./resources/en.json')),
}
